import { COOKIE_CUSTOMER_IDENTIFIER } from "utilities/consts";
import { CustomerData } from "types/Customer";
import { CustomerIdentifierType } from "hooks/auth/useLogin";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAppCookie, getAppCookie } from "utilities/cookies";

export const fetchIdentifierFromStorage = createAsyncThunk(
	'auth/fetchIdentifierFromStorage',
	async () => {
		const storageData = await getAppCookie(COOKIE_CUSTOMER_IDENTIFIER);

		if (storageData) {
			return storageData as CustomerIdentifierType;
		}

		return {} as CustomerIdentifierType;
	}
);

export const authSlice = createSlice({
	name: "auth",
	initialState: {
		loginRedirect: undefined,
		identifier: {} as CustomerIdentifierType,
		identifierLoaded: false,
		authInitialized: false,
		customer: {} as CustomerData,
		state: undefined,
	},
	reducers: {
		setLoginRedirect: (state, action) => {
			state.loginRedirect = action.payload;
		},
		setCustomer: (state, action) => {
			let customer = action.payload;
			let loyaltyCardDetails = {
				hasLoyaltyCard: false,
				loyaltyCardBarcode: 0,
			};

			customer?.attributes.forEach((attribute: any) => {
				if (
					attribute.attribute_name === "Loyalty Card Barcode" || attribute.attribute_name ==="loyalty_card_barcode" &&
					attribute.attribute_value
				) {
					loyaltyCardDetails.hasLoyaltyCard = true;
					loyaltyCardDetails.loyaltyCardBarcode = parseInt(
						attribute.attribute_value,
					);
				}
			});

			customer = {
				...customer,
				...loyaltyCardDetails,
			};

			state.customer = customer;
		},
		updateCustomer: (state, action) => {
			state.customer = {
				...state.customer,
				...action.payload,
			};
		},
		setIdentifier: (state, action) => {
			state.identifier = action.payload;
			state.identifierLoaded = Object.keys(action.payload).length > 0;
		},
		logout: (state) => {

			state.identifier = {} as CustomerIdentifierType;
			state.customer = {} as CustomerData;
			state.identifierLoaded = false;
			deleteAppCookie(COOKIE_CUSTOMER_IDENTIFIER);
		},
		setState: (state, action) => {
			state.state = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchIdentifierFromStorage.fulfilled, (state, action) => {

			if (typeof action.payload === 'string') {
				state.identifier = JSON.parse(action.payload);
			} else {
				state.identifier = action.payload;
			}
			state.identifierLoaded = Object.keys(state.identifier).length > 0;
			state.authInitialized = true;
		});
		builder.addCase(fetchIdentifierFromStorage.rejected, (state) => {
			state.authInitialized = true;
		});
	},
});

export const {
	setLoginRedirect,
	setCustomer,
	updateCustomer,
	setIdentifier,
	logout,
	setState,
} = authSlice.actions;

export default authSlice.reducer;
